import { formatDateLabel } from "@/lib/utils";
import { PrinterCheck } from "lucide-react";


export function PrintStatusBadge({
    username,
    printDate,
}: {
    username?: string;
    printDate?: string;
}) {
    const isPrinted = Boolean(username && printDate);

    return (
        <span
            className={`inline-flex items-center gap-1 text-[10px] font-medium px-2 py-1 rounded-full border w-fit whitespace-nowrap
        ${isPrinted
                    ? "bg-green-100 text-green-700 border-green-300"
                    : "bg-gray-100 text-gray-500 border-gray-300"
                }
      `}
        >
            {/* Shown only when printed */}
            {isPrinted && <PrinterCheck className="h-3.5 w-3.5 flex-shrink-0" />}

            {/* Text */}
            {isPrinted ? (
                <span className="whitespace-nowrap">
                    Printed by <b>{username}</b> • {formatDateLabel(printDate!)}
                </span>
            ) : (
                <span>Not Printed</span>
            )}
        </span>
    );
}
